import './request'
import Request from '@hotmart-org-ca/request'

import RequestHelper from 'common/helpers/request'
import { Transmission, OnFireLanguageResponse, Visibility } from 'modules/transmission/types'
import { Feedback, NextTransmissionInfo, TransmissionInfo } from '../types'

export default class TransmissionService {
  static getTransmission = async (code: string, visibility: string): Promise<Transmission> => {
    try {
      const method = TransmissionService.getMethod(visibility)
      const response = await Request(method, { code }) as Transmission

      return response
    } catch (error) {
      throw RequestHelper.errorHandling(error)
    }
  }

  static getMethod(visibility: string) {
    switch (visibility) {
      case 'PRIVATE': return 'get.schedule.private'
      case 'PUBLIC': return 'get.schedule.public'
      case 'HOTMART': return 'get.schedule.private.hotmart'
      default: return 'get.schedule.public'
    }
  }

  static getTransmissionInfo = async (code: string): Promise<TransmissionInfo> => {
    try {
      const response = await Request('get.schedule.info', { code }) as TransmissionInfo

      return response
    } catch (error) {
      throw RequestHelper.errorHandling(error)
    }
  }

  static async getTransmissionConfig(code: string) {
    try {
      const response = await Request('get.config', { code })

      return response
    } catch (error) {
      throw RequestHelper.errorHandling(error)
    }
  }

  static getNextTransmissions = async (code: string): Promise<NextTransmissionInfo[]> => {
    const response = await Request('get.schedule.next', { code }) as NextTransmissionInfo[]

    return response
  }

  static getFeedback = async (
    transmissionCode: string,
    leadCode: string
  ): Promise<Feedback | null> => {
    try {
      const payload = {
        leadCode,
        scheduleCode: transmissionCode
      }

      const response = await Request('get.schedule.feedback', payload) as Feedback

      return response
    } catch (error) {
      if (error?.response?.status === 404) {
        return null
      }
      throw error
    }
  }

  static saveFeedback = async (payload: {
    email: string,
    feedback?: string,
    leadCode: string,
    name: string,
    ratingStar: number,
    scheduleCode: string
  }): Promise<Feedback> => {
    const response = await Request('post.schedule.feedback', payload) as Feedback

    return response
  }

  static getOnFireLanguages = async (code: string) => {
    const response = await Request('get.onfire.languages', { code }) as OnFireLanguageResponse[]

    return response
  }

  static verifyAuthorizathion = async (transmissionCode: string) => {
    const res = await TransmissionService.getTransmission(transmissionCode, Visibility.PRIVATE)

    return res
  }
}
